var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicineTablett(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4683 3.97023C13.8323 1.60628 17.6649 1.60628 20.0289 3.97023C22.3929 6.33419 22.3929 10.1669 20.0289 12.5309L12.5289 20.0309C10.165 22.3948 6.33225 22.3948 3.96829 20.0309C1.60435 17.667 1.60431 13.8342 3.96828 11.4703L11.4683 3.97023ZM18.9683 5.0309C17.1901 3.25272 14.3071 3.25272 12.5289 5.0309L9.31025 8.24959L15.7496 14.6889L18.9683 11.4703C20.7465 9.69206 20.7465 6.80906 18.9683 5.0309ZM14.6889 15.7496L8.24959 9.31025L5.02894 12.5309C3.25079 14.309 3.25076 17.1921 5.02894 18.9703C6.80712 20.7484 9.69012 20.7484 11.4683 18.9703L14.6889 15.7496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineTablett);
export default __webpack_public_path__ + "static/media/medicine-tablett.c76349771613230431c085a9ca868d19.svg";
export { ForwardRef as ReactComponent };